/** The full-page login (Espotz-docs#2038). */
export const LOGIN_PATH = '/login';

/**
 * A `returnTo` we're willing to send someone to after login: a same-origin path only. Anything
 * else (`https://evil.com`, `//evil.com`, `javascript:`, a backslash trick) is dropped, so the
 * login page can't be used as an open redirect.
 */
export function safeReturnTo(raw: string | null | undefined): string | null {
  if (
    !raw ||
    !raw.startsWith('/') ||
    raw.startsWith('//') ||
    raw.includes('\\')
  )
    return null;
  try {
    const url = new URL(raw, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    const path = url.pathname + url.search + url.hash;
    // Never come back to the login page itself.
    return url.pathname === LOGIN_PATH ? null : path;
  } catch {
    return null;
  }
}

/**
 * Where login sends you: the page you were heading for, otherwise home, which is the feed once
 * you're logged in.
 */
export const loginDestination = (returnTo: string | null | undefined): string =>
  safeReturnTo(returnTo) ?? '/';

/** `/login`, carrying where to go afterwards when that isn't home. */
export function loginHref(returnTo?: string | null): string {
  const safe = safeReturnTo(returnTo);
  return safe && safe !== '/'
    ? `${LOGIN_PATH}?returnTo=${encodeURIComponent(safe)}`
    : LOGIN_PATH;
}
